module.exports = __webpack_public_path__ + "static/img/partIcon02.049a4c6b.png";